export const questions: Array<[string, string]> = [
  [
    'Professional level?',
    'Chemical process technicians, chemical engineers, plant operators, production specialists, maintenance professionals, quality specialists worldwide.',
  ],
  [
    'Content depth?',
    'From industrial chemistry fundamentals through advanced unit operations, chemical production, process control, safety management, and optimization. Scales from foundational to professional expertise.',
  ],
  ['International?', 'Yes. Universal chemistry and process engineering principles with guidance for regional industrial codes and standards.'],
  ['Editable?', 'Yes. Professional-grade PDFs for reference and technical documentation.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, 160 technical terms, 24 calculation examples, 45 equipment categories, 12 industry scenarios, 6 safety/quality scenarios. Everything designed so you never struggle with technical understanding again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
